export default __webpack_public_path__ + "maps-examples-annotation-views-thumbnail-960-3f81e93cfcda0add1054c9061809d06f.webp";